import { render, staticRenderFns } from "./data3.vue?vue&type=template&id=111e035d"
import script from "./data3.vue?vue&type=script&lang=js"
export * from "./data3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports